// eslint-disable-next-line no-unused-vars
import React, { useState } from "react";
import { Dropdown, Menu, Drawer } from "antd";
import Logo from '../assets/img/om-icon.png';
import ChatBubble from '../assets/img/chat_bubble.png';
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { getUserDetail, logout } from "../util/util";
import PageHeader from "../layouts/PageHeader";
import { useUnreadCount } from "../hooks/useUnreadCount";
import { Bell } from "lucide-react";
import NotificationsDrawer from "../components/NotificationsDrawer";
export const DashboardLayout = (props) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 900);
  // control whether sidebar is expanded (wide) or collapsed (narrow)
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [notificationsDrawerOpen, setNotificationsDrawerOpen] = useState(false);
  const { data: unreadCountData } = useUnreadCount();
  const unreadCount = unreadCountData?.data || 0;

  // Helper for sidebar-aware navigation
  const handleSidebarNav = (path) => {
    navigate(path);
    if (window.innerWidth <= 900) setSidebarOpen(false);
  };

  // Responsive sidebar toggle
  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const logoutUser = () => {
    logout();
    secureLocalStorage.removeItem('expiresAt');
    window.location.href = '/onboard/login';
  }

  return (
    <>
      <div>
      {/* Navbar: fixed to top so it does not scroll with content; hide hamburger on mobile, show on desktop */}
      <nav className="navbar bg-om-dark navbar-dark" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200, height: 64 }}>
        <div className="container-fluid" style={{ position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap' }}>
          <div className="navbar-brand dashboard-navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>
            <img src={Logo} alt="om-icon" style={{ marginLeft: 20 }} />
          </div>
          <style>{`
            @media (max-width: 900px) {
              .dashboard-navbar-brand {
                margin-left: -20px !important;
                padding-left: 0 !important;
              }
              .container-fluid {
                padding-left: 0 !important;
              }
              .dashboard-hamburger {
                margin-left: 0 !important;
                display: none !important;
              }
            }
            @media (min-width: 901px) {
              .dashboard-navbar-brand {
                margin-left: 0;
                padding-left: 0;
              }
              .dashboard-hamburger {
                display: inline-flex !important;
              }
            }
            @media (max-width: 600px) {
              .user-name-label {
                display: none !important;
              }
            }
            @media (max-width: 900px) {
              .notification-count {
                font-size: 8px !important;
              }
            }
          `}</style>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setNotificationsDrawerOpen(prev => !prev)}
                aria-expanded={notificationsDrawerOpen}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  position: 'relative',
                  padding: 8,
                  borderRadius: 8,
                  color: '#fff'
                }}
              >
                <Bell size={20} />
                {unreadCount > 0 && (
                  <span className="notification-count" style={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    background: '#ff4757',
                    color: '#fff',
                    borderRadius: '50%',
                    width: 16,
                    height: 16,
                    fontSize: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600
                  }}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </button>
            </div>
            <Dropdown
              overlay={
                <Menu style={{ borderRadius: 12, minWidth: 180, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                  <Menu.Item key="settings" onClick={() => navigate('/dashboard/settings')} style={{ fontWeight: 600 }}>
                    <i className="bi bi-gear me-2" /> Settings
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item key="logout" onClick={logoutUser} style={{ fontWeight: 600 }}>
                    <i className="bi bi-box-arrow-right me-2" /> Logout
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
              placement="bottomRight"
            >
              <button className='btn btn-white' style={{ display: 'flex', alignItems: 'center' }}>
                <i className="bi bi-person-circle" style={{fontSize:'15px'}} />
                <span className="ms-1 user-name-label">{getUserDetail()?.name}</span>
                <i className="bi bi-caret-down ms-2" style={{fontSize:'12px'}} />
              </button>
            </Dropdown>
          </div>
        </div>
      </nav>
      {/* Spacer to offset fixed navbar so content isn't hidden under it */}
      <div style={{ height: 64, width: '100%', background: '#181526' }} />
      
  <div style={{ display: 'flex', width: '100%', minHeight: 'auto', overflow: 'visible' }}>
        {/* Sidebar: only on desktop/tablet */}
        {!isMobile && sidebarOpen && (
          <CustomSidebar navigate={handleSidebarNav} expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />
        )}
  <div style={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'visible', position: 'relative', marginLeft: (!isMobile && sidebarOpen) ? (sidebarExpanded ? 280 : 100) : 0 }}>
          <PageHeader />
          <div
            className="omk-bg-secondary padding-general-mobile dashboard-content-area"
            style={{ flexGrow: 1, minWidth: 0, overflow: 'visible', paddingBottom: isMobile ? 70 : undefined }}
          >
            {props.children}
          </div>
          {/* Mobile bottom nav bar */}
          {isMobile && <MobileBottomNav navigate={handleSidebarNav} />}
        </div>
      </div>
    </div>
    <Drawer
      title="Notifications"
      placement="right"
      onClose={() => setNotificationsDrawerOpen(false)}
      open={notificationsDrawerOpen}
      width={360}
      closeIcon={<span style={{ fontSize: 20, color: '#000' }}>×</span>}
      bodyStyle={{ padding: 0, paddingBottom: isMobile ? 80 : 0, overflowY: 'auto' }}
      headerStyle={{ padding: '12px 16px' }}
      drawerStyle={{ zIndex: 4000, height: isMobile ? 'calc(100vh - 8%)' : undefined }}
    >
      <NotificationsDrawer onClose={() => setNotificationsDrawerOpen(false)} />
    </Drawer>
    </>
  );
}



// Custom Sidebar component (moved outside DashboardLayout)
function CustomSidebar({ navigate, expanded, setExpanded }) {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);
  const menuItems = [
    { label: 'Home', icon: 'home', path: '/dashboard' },
    { label: 'Products', icon: 'diamond', path: '/dashboard/products' },
    { label: 'Transactions', icon: 'receipt', path: '/dashboard/transactions' },
    { label: 'Profile', icon: 'person', path: '/dashboard/profile' },
    { label: 'Settings', icon: 'settings', path: '/dashboard/settings' },
    { label: 'Feedback', path: '/dashboard/feedback' },
  ];
  const currentPath = window.location.pathname;
  // Vertical sidebar on the left
  return (
    <div
      style={{
        width: expanded ? 280 : 100,
        background: '#fff',
        borderRight: '1px solid #f0f0f0',
        height: 'calc(100vh - 64px)',
        top: 64,
        left: 0,
        position: 'fixed',
        transition: 'width 0.2s',
        display: 'flex',
        flexDirection: 'column',
        alignItems: expanded ? 'flex-start' : 'center',
        zIndex: 1100,
        overflowY: 'auto'
      }}
      className="custom-sidebar shadow-sm"
    >
      {/* Logo */}
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: expanded ? 'flex-start' : 'center', padding: expanded ? '8px 18px 4px 18px' : '8px 0 4px 0' }}>
        <img src={Logo} alt="OM Logo" style={{ width: 36, height: 36, borderRadius: 8 }} />
      </div>
      {/* Hamburger above Home */}
      <button
        onClick={() => setExpanded(e => !e)}
        aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
        style={{
          background: 'none',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          margin: expanded ? '0 0 10px 10px' : '0 0 10px 0',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          fontSize: 24,
          color: '#184b18',
        }}
      >
        <i className="bi bi-list" />
      </button>
      {/* Divider under hamburger (only when collapsed) */}
      {!expanded && (
        <div style={{
          width: '60%',
          height: 1,
          background: '#e0e0e0',
          margin: '0 0 10px 0',
          alignSelf: 'center',
          borderRadius: 1,
        }} />
      )}
      {/* Menu items */}
      <div style={{ width: '100%', marginTop: 8 }}>
        {menuItems.map((item, idx) => {
          const isActive = currentPath === item.path || (item.path !== '/dashboard' && currentPath.startsWith(item.path));
          const isHovered = hoveredIndex === idx;
          return (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              className="sidebar-menu-btn"
              data-active={isActive ? "true" : undefined}
              onMouseEnter={() => setHoveredIndex(idx)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: expanded ? 'row' : 'column',
                alignItems: expanded ? 'flex-start' : 'center',
                textAlign: expanded ? 'left' : 'center',
                gap: expanded ? 18 : 0,
                background: isActive
                  ? 'rgba(0, 200, 83, 0.12)'
                  : isHovered
                    ? '#c3c3c363'
                    : 'none',
                border: 'none',
                outline: 'none',
                padding: expanded ? '12px 18px' : '15px 0',
                fontWeight: 600,
                fontSize: 16,
                color: isActive ? '#184b18' : '#111',
                borderRadius: 18,
                marginBottom: 6,
                justifyContent: 'center',
                transition: 'background 0.2s, color 0.2s',
              }}
              title={item.label}
            >
              {item.label === 'Feedback' ? (
                <img 
                  src={ChatBubble} 
                  alt="Feedback" 
                  style={{ 
                    width: 20, 
                    height: 20, 
                    flexShrink: 0,
                    filter: isActive ? 'brightness(0)' : 'brightness(0)'
                  }} 
                />
              ) : (
                <omk-icon slot="nav-icon" style={{ fontSize: 20, flexShrink: 0, color: isActive ? '#000000ff' : '#111' }}>{item.icon}</omk-icon>
              )}
              {expanded
                ? <span style={{ flex: 1, alignSelf: 'center', minWidth: 0, color: isActive ? '#000000ff' : '#111' }}>{item.label}</span>
                : <span style={{ fontSize: 13, marginTop: 2, color: isActive ? '#000000ff' : '#111' }}>{item.label}</span>
              }
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Mobile bottom nav bar: only icons, fixed at bottom
function MobileBottomNav({ navigate }) {
  const menuItems = [
    { label: 'Home', icon: 'home', path: '/dashboard' },
    { label: 'Products', icon: 'diamond', path: '/dashboard/products' },
    { label: 'Transactions', icon: 'receipt', path: '/dashboard/transactions' },
    { label: 'Profile', icon: 'person', path: '/dashboard/profile' },
    { label: 'Settings', icon: 'settings', path: '/dashboard/settings' },
    { label: 'Feedback', path: '/dashboard/feedback' },
  ];
  const currentPath = window.location.pathname;
  return (
    <nav className="mobile-bottom-nav" style={{
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100vw',
      background: '#fff',
      borderTop: '1px solid #eee',
      zIndex: 3000,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      height: 56,
      boxShadow: '0 -2px 12px rgba(0,0,0,0.04)',
      padding: 0,
    }}>
      {menuItems.map((item, idx) => {
        const isActive = currentPath === item.path || (item.path !== '/dashboard' && currentPath.startsWith(item.path));
        return (
          <button
            key={item.label}
            onClick={() => navigate(item.path)}
            className="mobile-bottom-nav-btn"
            style={{
              background: 'none',
              border: 'none',
              outline: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              color: isActive ? '#00b050' : '#888',
              fontSize: 'clamp(8px, 2.5vw, 11px)',
              padding: '2px',
              height: '100%',
              cursor: 'pointer',
              minWidth: 0,
              gap: 0,
            }}
            aria-label={item.label}
          >
            {item.label === 'Feedback' ? (
              <img 
                src={ChatBubble} 
                alt="Feedback" 
                style={{ 
                  width: 'clamp(18px, 5vw, 24px)', 
                  height: 'clamp(18px, 5vw, 24px)', 
                  marginBottom: 0,
                  filter: isActive ? 'brightness(0) saturate(100%) invert(32%) sepia(98%) saturate(1943%) hue-rotate(127deg) brightness(96%) contrast(105%)' : 'brightness(0) saturate(100%) invert(58%) sepia(11%) saturate(11%) hue-rotate(22deg) brightness(91%) contrast(87%)'
                }} 
              />
            ) : (
              <omk-icon slot="nav-icon" style={{ fontSize: 'clamp(18px, 5vw, 24px)', color: isActive ? '#00b050' : '#888', marginBottom: 0 }}>{item.icon}</omk-icon>
            )}
            {/* Label hidden - icons only */}
          </button>
        );
      })}
      <style>{`
        .mobile-bottom-nav {
          box-shadow: 0 -2px 12px rgba(0,0,0,0.04);
        }
        .mobile-bottom-nav-btn:active {
          background: #e6f9ed;
        }
        @media (min-width: 901px) {
          .mobile-bottom-nav {
            display: none !important;
          }
        }
      `}</style>
    </nav>
  );
}
